import { createEffect, createEvent, createStore, restore, sample } from 'effector'

import { env } from '@/shared/config'

export const scriptLoaded = createEvent()

export const $googleScriptLoaded = createStore(false).on(scriptLoaded, () => true)

export const accessTokenReceived = createEvent<{ accessToken: string; state: string }>()

const googleInitFx = createEffect<void, boolean>(() => {
    window.google.accounts.id.initialize({
        client_id: env.OAUTH_GOOGLE_CLIENT_ID,
        //@ts-expect-error почему-то в типах нет state
        callback: ({ credential, state }) => accessTokenReceived({ accessToken: credential, state: state ?? '' }),
    })

    return true
})

export const $googleInitialized = restore(googleInitFx, false)

sample({
    clock: scriptLoaded,
    target: googleInitFx,
})
